import React from 'react';
import styled from 'styled-components';

import { FileManager } from '../components/file-manager/file-manager';
import { Stack } from '../components/stack/stack';
import { useApplyLangFromUrl } from '../hooks/use-apply-lang-from-url';
import { SharedLinkHeader } from '../layout/shared-link-header';
import { ProjectState } from '../state/project-state/project-state';

const SharedFolderRoute = () => {
  useApplyLangFromUrl();

  return (
    <Layout>
      <SharedLinkHeader />
      <MainContent>
        <SharedFolderContainer>
          <ProjectState>
            <FileManager />
          </ProjectState>
        </SharedFolderContainer>
      </MainContent>
    </Layout>
  );
};

const Layout = styled.div`
  height: 100vh;
  width: 100vw;
  display: grid;
  grid-template-rows: auto 1fr;
  background-color: #f5f6f8;
`;

const MainContent = styled(Stack).attrs({
  direction: 'column',
  padding: 0,
})`
  height: 100%;
  overflow: hidden;
`;

const SharedFolderContainer = styled(Stack).attrs({
  direction: 'column',
  padding: 0,
})`
  height: 100%;
  overflow: auto;
`;

export { SharedFolderRoute };
